import { useStore } from 'effector-react';
import { $queryParams } from 'models/location';
import { useEffect } from 'react';

const usePromocode = () => {
    const { promocode } = useStore($queryParams);

    useEffect(() => {
        if (promocode) {
            try {
                localStorage.setItem('promocode', promocode);
            } catch (e) {
                console.error('Cannot put promocode into the local storage');
            }
        }
    }, [promocode]);

    const getPromocode = () => {
        return localStorage.getItem('promocode') || undefined;
    };

    const clearPromocode = () => {
        localStorage.removeItem('promocode');
    };

    return { getPromocode, clearPromocode };
};

export default usePromocode;
